import React, {ReactNode, useEffect, useState} from 'react';
import {DetailGrid, Utility, wdiCore} from '@/components/GridWidget';
import {NsGrid} from '@/components/GridWidget/GridDefProps';
import {WdiCardTitle, WdiModalAppResult, WdiModalProps} from '@/components/WdiControls';
import {Button, Dropdown, Menu, message} from 'antd';
import {initFieldDisplayFormater, TableColumnRanderFormats,} from '@/components/WdiBus/TableColumnRanderFormats';
import DataStore from '@/components/GridWidget/DataStore';
import {ResponseStatus} from '@/utils/request';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {ImportModalApp} from '@/components/WdiControls/WdiImport';
import {Enum} from '@/enums/system';
import {GridApi} from '@/services/gridapi';
import FormBPDetailEditApp from '@/pages/project/GeneralProjectApply/components/detail-edit';
import {ToExcelProps} from '@/components/WdiControls/WdiExcel';
import {BO} from '@/services/mdm/bo';
import {EC} from '@/services/mdm/ec';
import {Product} from '@/services/mdm/product';

const ModalAppTypeEnums = {
  None: 0,
  Insert: 1,
  Edit: 2,
  Import: 3,
};

export type DetailForApplyProps = {
  data?: any;
  dataSource: any[];
  onChange?: (dataSource: any) => void;
};

const FormBPDetailsForApplyPanel: React.FC<DetailForApplyProps> = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const {data, dataSource, onChange} = props;
  const [importExcels, setImportExcels] = useState<ToExcelProps[]>([]);
  const [importModalProps, setImportModalProps] = useState<WdiModalProps>({visible: false});
  const [editModalProps, setEditModalProps] = useState<WdiModalProps>({visible: false});

  const onEditClose = () => {
    setEditModalProps({visible: false, title: '', type: ModalAppTypeEnums.None, id: null});
  };
  const onEditSave = (result?: WdiModalAppResult) => {
    if (result && result.code === ResponseStatus.SUCCESS) {
      const row = result?.data;
      if (editModalProps.type === ModalAppTypeEnums.Edit) {
        const record = editModalProps.data.row;
        const newItem = {...row};
        newItem.uid = record.uid;
        const newDataSouce = DataStore.edit(dataSource, newItem);
        onChange?.(newDataSouce);
      } else if (editModalProps.type === ModalAppTypeEnums.Insert) {
        const newItem = {...row};
        onChange?.(DataStore.add(dataSource, newItem));
      }
    }
    setEditModalProps({visible: false, title: '', id: null});
  };

  const onImportClose = () => {
    setImportModalProps({visible: false, title: '', id: null});
  };

  const onImportSave = (uploadResult: any) => {
    if (uploadResult.code == ResponseStatus.SUCCESS) {
      onChange?.(DataStore.init(uploadResult?.data?.data));
      // const rows = uploadResult?.data?.data;
      // if (uploadResult?.data?.exProperty) {
      //   if (rows && rows.length > 0) {
      //     onChange?.(DataStore.addMulti([], rows));
      //   }
      // } else {
      //   let resultData = [...dataSource];
      //   if (rows && rows.length > 0) {
      //     rows.forEach((item: any) => {
      //       let record = resultData.find(row => row.boId == item.boId && row.ecId == item.ecId);
      //       if (record) {
      //         record.amount = wdiCore.Number.ToString(item?.amount, 2);
      //         record.remark = item?.remark;
      //         resultData = DataStore.edit(resultData, record);
      //       } else {
      //         resultData = DataStore.add(resultData, item);
      //       }
      //     });
      //   }
      //   onChange?.(DataStore.init(resultData));
      // }
    }
    setImportModalProps({
      visible: false,
      title: '',
      type: ModalAppTypeEnums.None,
      id: null,
      data: null,
    });
  };

  useEffect(() => {
    GridApi.searchConfig({id: 'FormBudgetProjectDetail', allowModifyColumns: false}).then(
      (response) => {
        const settings: any = Object.assign({}, response.data, {
          actionsAlign: NsGrid.ActionsAlign.Left,
          showAggr: true,
          filterMenuActions: (actions: any, record: any) => {
            const newActions: any[] = [];
            if (actions) {
              actions.forEach((item: any) => {
                if (item.name == 'SystemDelete') {
                  if (!record.budgetProjectDetailId) {
                    newActions.push(item);
                  }
                } else {
                  newActions.push(item);
                }
              });
            }
            return newActions;
          },
        });

        initFieldDisplayFormater(settings.formSchema.allFields);
        settings.formSchema.allFields.amount.getDisplayFormater = (
          text: any,
          record: any,
          index: any,
        ) => {
          return wdiCore.Number.ToString(record.amount, 2);
        };

        settings.formSchema.allFields.amount.aggr = TableColumnRanderFormats.sumAggr('amount', 2);

        settings.formSchema.allFields.rowNumber.width = 80;

        setGridSettings(settings);
        setIsLoaded(true);
      },
    );
  }, []);

  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true,
    },
  };
  if (pageGridSettings && pageGridSettings.formSchema && pageGridSettings.formSchema.actions) {
    Utility.setActionCallback(
      pageGridSettings.formSchema.actions,
      'SystemDelete',
      async (grid: any, action: any, record: any) => {
        if (confirm('确定要删除该行吗？')) {
          onChange?.(DataStore.del(dataSource, record.uid));
          message.success('删除成功');
        }
      },
    );
    Utility.setActionCallback(
      pageGridSettings.formSchema.actions,
      'Update',
      async (grid: any, action: any, record: any) => {
        const context = grid.getContext();
        setEditModalProps({
          visible: true,
          title: '编辑分配明细',
          type: ModalAppTypeEnums.Edit,
          id: record.formBudgetProjectDetailId,
          data: {
            row: record,
            rows: context.dataSource,
            rowIndex: DataStore.getRowIndex(context.dataSource, record.uid),
            pageTypeId: context.params.pageTypeId,
            bohqId: context.params.bohqId,
          },
        });
      },
    );
  }

  useEffect(() => {
    const boColumns = [
      {name: 'boName1', displayName: '一级使用部门名称'},
      {name: 'boName2', displayName: '二级使用部门名称'},
      {name: 'boName3', displayName: '三级使用部门名称'},
      {name: 'boName4', displayName: '四级使用部门名称'},
    ];
    const boSheet = {
      dataLoading: async (params: any) => {
        return await BO.exportEx(
          Object.assign(
            {
              isActive: true,
              withPermissions: true,
              boLevels: String(Enum.BOLevel.BO4),
            },
            params,
          ),
        );
      },
      data: null,
      names: boColumns,
      sheetName: '使用部门',
    };

    const ecColumns = [
      {name: 'ecName1', displayName: '费用大类名称'},
      {name: 'ecName2', displayName: '费用小类名称'},
      {name: 'ecName3', displayName: '费用项名称'},
      {name: 'remark', displayName: '费用项描述'}

    ];
    const ecSheet = {
      dataLoading: async (params: any) => {
        return await EC.queryForSheet(
          Object.assign({
            ecLevel: Enum.ECLevel.EC3,
            pageTypeId: Enum.PageType.PROJECT_GENERAL,
            bohqId: data?.bohqId
          }, params),
        );
      },
      data: null,
      names: ecColumns,
      sheetName: '费用类别',
    };
    const productColumns = [
      {name: 'productCode', displayName: '品牌编号'},
      {name: 'productName', displayName: '品牌名称'},
    ];
    const productSheet = {
      dataLoading: async (params: any) => {
        return await Product.searchLevel1(
          Object.assign(
            {
              isActive: true,
              ecLevel: Enum.ProductLevel.PRODUCT1,
              withPermissions: true,
            },
            params,
          ),
        );
      },
      data: null,
      names: productColumns,
      sheetName: '品牌',
    };
    const importExcels: ToExcelProps[] = [];
    importExcels.push({
      name: '全部下载',
      sheetProps: [boSheet, ecSheet, productSheet],
    });

    importExcels.push(
      {
        name: '使用部门列表',
        sheetProps: [boSheet],
      },
      {
        name: '费用类别列表',
        sheetProps: [ecSheet],
      },
      {
        name: '品牌列表',
        sheetProps: [productSheet],
      },
    );

    setImportExcels(importExcels);
  }, [props]);

  return (
    <>
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title="费用分配信息"/>}
        extra={
          <>
            <Dropdown.Button
              buttonsRender={(buttons: ReactNode[]) => {
                return [buttons[0], <Button type={"primary"} style={{width: 50, fontSize: 12}}>更多</Button>]
              }}
              type="primary"
              onClick={() => {
                setEditModalProps({
                  visible: true,
                  title: '新建分配明细',
                  type: ModalAppTypeEnums.Insert,
                  id: null,
                  data: {
                    row: null,
                    rows: dataSource,
                    rowIndex: -1,
                    pageTypeId: data.pageTypeId,
                    bohqId: data.bohqId,
                  },
                });
              }}
              overlay={
                <Menu
                  items={[
                    {
                      key: 'import',
                      label: '导入',
                      onClick: () => {
                        setImportModalProps({
                          title: '费用分配信息导入',
                          visible: true,
                        });
                        return true;
                      },
                    },
                  ]}
                />
              }
              style={{float: 'right'}}
            >
              新建
            </Dropdown.Button>
          </>
        }
      >
        {isLoaded && importModalProps.visible && (
          <ImportModalApp
            title={importModalProps.title}
            visible={importModalProps.visible}
            settingsUrl="/expenseapi/buttons/importSettings"
            uploadingUrl="/expenseapi/buttons/importUploading"
            importExcels={importExcels}
            onClose={onImportClose}
            onSave={onImportSave}
            clientParameters={{
              isCreate: !data.budgetProject,
              formBudgetProject: data,
              formBudgetProjectDetails: JSON.stringify(dataSource),
            }}
          />
        )}
        {isLoaded &&
          editModalProps.visible &&
          (editModalProps.type === ModalAppTypeEnums.Insert ||
            editModalProps.type === ModalAppTypeEnums.Edit) && (
            <FormBPDetailEditApp {...editModalProps} onClose={onEditClose} onSave={onEditSave}/>
          )}
        {isLoaded && <DetailGrid {...pageGridSettings} params={data} autoColumn={['rowNumber']}/>}
      </WdiPanel>
    </>
  );
};
export default FormBPDetailsForApplyPanel;

export const FormBPDetailsForApprovalPanel: React.FC<DetailForApplyProps> = (props) => {
  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});

  useEffect(() => {
    GridApi.searchConfig({id: 'FormBudgetProjectDetail', allowModifyColumns: false}).then(
      (response) => {
        const settings: any = Object.assign({}, response.data, {
          actionsAlign: NsGrid.ActionsAlign.None,
          showAggr: true,
        });

        initFieldDisplayFormater(settings.formSchema.allFields);

        settings.formSchema.allFields.amount.aggr = TableColumnRanderFormats.sumAggr('amount', 2);

        settings.formSchema.allFields.rowNumber.width = 80;
        setGridSettings(settings);

        setIsLoaded(true);
      },
    );
  }, []);

  const {dataSource} = props;
  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
  };

  return (
    <WdiPanel
      title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title="费用分配信息"/>}
      collapsed={true}
    >
      {isLoaded && <DetailGrid {...pageGridSettings} />}
    </WdiPanel>
  );
};
